// A minimal lighthouse + beam glyph in the Beacon amber.
export function Logo({ className = "h-7 w-7" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* The beam — diagonal warm glow */}
      <path
        d="M16 10 L4 4 L4 8 L16 14 Z"
        fill="hsl(var(--beam))"
        opacity="0.45"
      />
      <path
        d="M16 10 L28 4 L28 8 L16 14 Z"
        fill="hsl(var(--beam))"
        opacity="0.45"
      />
      {/* The lamp */}
      <circle cx="16" cy="11" r="3" fill="hsl(var(--beam))" />
      <circle cx="16" cy="11" r="1.5" fill="hsl(var(--beam-glow))" />
      {/* The lighthouse tower */}
      <path
        d="M13 14 L13 26 L19 26 L19 14 Z"
        fill="currentColor"
        opacity="0.85"
      />
      <rect x="12" y="26" width="8" height="2" rx="0.5" fill="currentColor" />
      <line x1="13" y1="18" x2="19" y2="18" stroke="hsl(var(--background))" strokeWidth="0.8" />
      <line x1="13" y1="22" x2="19" y2="22" stroke="hsl(var(--background))" strokeWidth="0.8" />
    </svg>
  );
}
